import { Component } from '@angular/core';
import { AuthService, UserData, UserDataService } from '@discoverer/app-core';
import { UserDataServiceInterface } from '@discoverer/attachments/services/user-data-service-interface.service';
import { Subscription } from 'rxjs';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        { provide: UserDataServiceInterface, useExisting: UserDataService }
    ]
})
export class AppComponent {
    public loggedIn = false;
    title = 'docepipeline';
    _sub: Subscription
    constructor(
        private _userDataService: UserDataServiceInterface,
        private _authService: AuthService,

    ) {
        console.log("Hello World")
        //this._authService.monitorForTokenParamAndFetchUser();
        this._authService.gatewayIdentityUserObservable.subscribe(user => {
            if (!!user) {
                console.log("🟢Authe")
                const userData = new UserData();
                userData.name = user.fullName;
                userData.email = user.email;
                userData.id = user.userId;
                userData.token = user.token;
                userData.roles = new Set<string>(user.roles);
                this._userDataService.setUser(userData);
                !!this._sub && this._sub?.unsubscribe()
            }
        });
        document.addEventListener("wheel", function (event) {
            ((document?.activeElement as any)?.type === "number") && (document?.activeElement as any)?.blur();
        });
        // Fix issue with new chrome material select bug:- https://github.com/angular/components/issues/28905
        document.addEventListener('DOMNodeInserted', function () {
            const elements = document.querySelectorAll('[aria-owns]');
            elements?.forEach(element => {
                element?.removeAttribute('aria-owns');
            });
        });
    }
}
